export default __webpack_public_path__ + "static/media/main_title_blog.2e59b63f.svg";